import { createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "../../../../Common/Interceptors/AxiosConfig";

const initialState = {
  errors: null,
  isLoading: false,
  isSuccess: false,
  dashboardData: null,
  selectedTimeframe: 'monthly',
  lastUpdated: null
};

const dashboardSlice = createSlice({
  name: "serviceProviderDashboard",
  initialState,
  reducers: {
    setErrors: (state, action) => {
      state.errors = action.payload;
    },
    setLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setSuccess: (state, action) => {
      state.isSuccess = action.payload;
    },
    setDashboardData: (state, action) => {
      state.dashboardData = action.payload;
    },
    setSelectedTimeframe: (state, action) => {
      state.selectedTimeframe = action.payload;
    },
    setLastUpdated: (state, action) => {
      state.lastUpdated = action.payload;
    },
    resetDashboard: (state) => {
      state.dashboardData = null;
      state.errors = null;
      state.isSuccess = false;
      state.lastUpdated = null;
    }
  }
});

export const {
  setErrors,
  setLoading,
  setSuccess,
  setDashboardData,
  setSelectedTimeframe,
  setLastUpdated,
  resetDashboard
} = dashboardSlice.actions;

// ✅ Get Dashboard Analytics
export const getDashboardAnalytics = (serviceId = null, type = 'Business') => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setErrors(null));

  try {
    const URL = serviceId
      ? `/dashboard/${type}/${serviceId}`
      : `/dashboard/hub`;
    const response = await axiosInstance.get(URL);
    const { status, message, data } = response?.data || {};

    if (status === "success") {
      dispatch(setDashboardData(data));
      dispatch(setLastUpdated(new Date().toISOString()));
      dispatch(setSuccess(true));
    } else {
      dispatch(setErrors({ message: message || "Failed to fetch dashboard analytics" }));
    }
  } catch (error) {
    const errorMsg = error?.response?.data?.message || error.message || "Something went wrong while loading dashboard";
    dispatch(setErrors({ message: errorMsg }));
  } finally {
    dispatch(setLoading(false));
  }
};

// ✅ Refresh Dashboard Data
export const refreshDashboardAnalytics = (serviceId = null, type = 'Business') => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setErrors(null));

  try {
    const URL = serviceId
      ? `/dashboard/${type}/${serviceId}`
      : `/dashboard/hub`;
    const response = await axiosInstance.get(URL);
    const { status, message, data } = response?.data || {};

    if (status === "success") {
      dispatch(setDashboardData(data));
      dispatch(setLastUpdated(new Date().toISOString()));
      dispatch(setSuccess(true));
    } else {
      dispatch(setErrors({ message: message || "Failed to refresh dashboard analytics" }));
    }
  } catch (error) {
    const errorMsg = error?.response?.data?.message || error.message || "Something went wrong while refreshing dashboard";
    dispatch(setErrors({ message: errorMsg }));
  } finally {
    dispatch(setLoading(false));
  }
};

export default dashboardSlice.reducer;

